import { memo } from "react";

import { css } from "@emotion/react";
import { ReactComponent as HighlightBrandLogoOnly } from "@hl/base-components/lib/assets/icons/brand-just-logo.svg";
import {
  bottomMargin,
  topMargin,
} from "@hl/communities-app/lib/styles/global/layout";

const PreviewContentFooter = () => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: flex-end;

        ${bottomMargin("5/12px")}
        ${topMargin("5/12px")}
      `}
    >
      <HighlightBrandLogoOnly
        css={css`
          width: 12px;
          height: 12px;
        `}
      />
    </div>
  );
};

export default memo(PreviewContentFooter);
